export const DeductionConstant = {
  DRIVER_LUMP_SUM_YEAR_START: 2020,
  DISABILITY_CARE_YEAR_START: 2021,
};
